const Fence = () => import('Views/fence/index');
const FenceAddEdit = () => import('Views/fence/fence-addEdit');
const DeviceFenceDetail = () => import('Views/fence/device-fence-detail');

export default[
  { path: '/fence', component: Fence },
  { path: '/fence-add', component: FenceAddEdit },
  { path: '/fence-edit/:id', component: FenceAddEdit },
  { path: '/device-fence-detail/:id', component: DeviceFenceDetail },
];



// WEBPACK FOOTER //
// ./src/router/fence.js